import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { APIProvider, Map, Polygon } from "@vis.gl/react-google-maps";
import { CatButton } from "blocks-nextjs/blocks-react/components/Button/Button";
import { CatIconEdit } from "blocks-nextjs/blocks-react/components/Icons/Edit/Edit";
import { CatIconStop } from "blocks-nextjs/blocks-react/components/Icons/Stop/Stop";
import React, { useCallback, useState } from "react";
import { getGoogleMapsApiKey } from "../../lib/getEnvVariables";
import useGlobalStore from "../../store/useGlobalStore";
import { Variant } from "../GlobalNotification/GlobalNotification";
import PolygonDrawingManager from "./PolygonDrawingManager";
const API_KEY = getGoogleMapsApiKey();
const MAP_ID = "project-geofence-map";
const DEFAULT_CENTER = { lat: 37.7749, lng: -122.4194 };
const DEFAULT_ZOOM = 13;
const SAVED_POLYGON_OPTIONS = {
    fillColor: "#3b82f6",
    fillOpacity: 0.35,
    strokeColor: "#2563eb",
    strokeOpacity: 0.9,
    strokeWeight: 3
};
const ProjectGeoFenceMap = ({ defaultCenter = DEFAULT_CENTER, defaultZoom = DEFAULT_ZOOM, initialPolygons = [], onPolygonSaved }) => {
    const [isDrawingMode, setIsDrawingMode] = useState(false);
    const [savedPolygons, setSavedPolygons] = useState(initialPolygons);
    const { setGlobalNotification } = useGlobalStore((state) => ({
        setGlobalNotification: state.setGlobalNotification
    }));
    const handleSavePolygon = useCallback((newPolygonPath) => {
        setSavedPolygons((prev) => [...prev, newPolygonPath]);
        setIsDrawingMode(false);
        setGlobalNotification({
            message: "Polygon saved successfully.",
            showNotification: true,
            type: Variant.success
        });
        onPolygonSaved?.(newPolygonPath);
    }, [onPolygonSaved, setGlobalNotification]);
    const toggleDrawingMode = useCallback(() => {
        setIsDrawingMode((prev) => !prev);
    }, []);
    return (_jsxs("div", { className: "w-[900px] h-[900px] relative", "data-test": "project-geofence-map", children: [_jsxs("div", { className: "absolute top-2.5 left-2.5 z-10 bg-white p-2.5 rounded shadow-md flex items-center gap-2.5", "data-test": "map-controls-panel", children: [_jsx(CatButton, { "data-test": "toggle-drawing-btn", onClick: toggleDrawingMode, size: "sm", variant: isDrawingMode ? "danger" : "primary", children: isDrawingMode ? (_jsxs(_Fragment, { children: ["Stop Drawing", _jsx(CatIconStop, { slot: "after" })] })) : (_jsxs(_Fragment, { children: ["Enable Polygon Draw", _jsx(CatIconEdit, { slot: "after" })] })) }), _jsxs("span", { className: "text-sm text-gray-600", "data-test": "saved-polygons-count", children: ["Saved: ", _jsx("strong", { children: savedPolygons.length })] })] }), _jsx(APIProvider, { apiKey: API_KEY, children: _jsxs(Map, { className: "w-full h-full", defaultCenter: defaultCenter, defaultZoom: defaultZoom, gestureHandling: "greedy", mapId: MAP_ID, children: [_jsx(PolygonDrawingManager, { isDrawing: isDrawingMode, onSavePolygon: handleSavePolygon }), savedPolygons.map((path, index) => (_jsx(Polygon, { fillColor: SAVED_POLYGON_OPTIONS.fillColor, fillOpacity: SAVED_POLYGON_OPTIONS.fillOpacity, paths: path, strokeColor: SAVED_POLYGON_OPTIONS.strokeColor, strokeOpacity: SAVED_POLYGON_OPTIONS.strokeOpacity, strokeWeight: SAVED_POLYGON_OPTIONS.strokeWeight }, `saved-polygon-${index}`)))] }) })] }));
};
export default ProjectGeoFenceMap;
